'use strict';

angular.module('impactx.dropzone').controller('DropzoneCtrl', DropzoneCtrl);

DropzoneCtrl.$inject = ['$scope', 'FileHelperService'];

function DropzoneCtrl($scope, FileHelperService) {
    var ctrl = this;
    this.handleFileSelect = function (evt)
    {
        var file = evt.currentTarget.files[0];
        $(this).val("");
        ctrl.handleFile(evt, file);
    };
    this.handleFile = function(evt, file)
    {
        if (!FileHelperService.checkAllowedFileWithError(file.name))
        {
            return;
        }
        setFormAsDirty();
        if($scope.clearFileOnUpload) {
            $scope.uploadFile = {};
        }
        if (!$scope.noRead) {
            $scope.uploadFile.fileName = file.name;
            var fileExtension = file.name.slice((file.name.lastIndexOf(".") - 1 >>> 0) + 2);
            var reader = new FileReader();
            reader.onload = function (evt)
            {
                $scope.$evalAsync(function ($scope)
                {
                    $scope.uploadFile.file = evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        }
        else {
            $scope.uploadFile.fileName = file.name;
            $scope.uploadFile.file = file;
        }
    };

    this.fileSelect = function ()
    {
        angular.element(document.querySelector('#fileInput' + $scope.dropzoneId)).click();
    };

    this.removeFile = function(event)
    {
        setFormAsDirty();
        event.stopPropagation();
        $scope.uploadFile.fileName = undefined;
        $scope.uploadFile.file = undefined;
        document.querySelector('#fileInput' + $scope.dropzoneId).value = "";
    };

    function setFormAsDirty() {
        if($scope.formController) {
            $scope.formController.$setDirty();
        }
    }
}